const SENSITIVE_KEYS = [
  'password',
  'token',
  'secret',
  'authorization',
  'api_key',
  'apikey',
  'email',
  'phone',
];

const MAX_DEPTH = 4;

const isSensitiveKey = (key: string) =>
  SENSITIVE_KEYS.some((sensitive) => key.toLowerCase().includes(sensitive));

export const redactSensitive = (value: unknown, depth = 0): unknown => {
  if (depth > MAX_DEPTH) {
    return '[REDACTED]';
  }

  if (Array.isArray(value)) {
    return value.map((item) => redactSensitive(item, depth + 1));
  }

  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>);
    const redacted: Record<string, unknown> = {};
    for (const [key, entryValue] of entries) {
      redacted[key] = isSensitiveKey(key)
        ? '[REDACTED]'
        : redactSensitive(entryValue, depth + 1);
    }
    return redacted;
  }

  return value;
};
